import api from '../instance'

export function fetchAdjustApportionment(data) {
  return api.put('/apportionment', data)
}
